import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from 'react-redux';
import { ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IBasicCenterListResponse, IAppState } from '@nkr/store/index';
import { ICenterBase, ICenter } from '@nkr/models/index';
import { Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { IDashContactsResponse } from '@nkr/store/reports';
import { IDashContacts } from '@nkr/models/index';
import { downloadFile } from '@nkr/services/download-file';
import Filter from './filter';
import Grid from './grid';
import NumbersToSelect from './numbers-to-select';
import { OrganType } from '@nkr/enums/organ-type';

interface ContactsPayload {
    includeNkr: boolean,
    includeDash: boolean,
    startDate: string,
    endDate: string,
    organType: number,
    includeNdd: boolean,
    includeDd: boolean,
    includeSv: boolean,
    includeFv: boolean,
    ruleOut: number,
    emrStatus: number,
    centerId: number,
    limitStart: number,
    limitEnd: number
}

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    centerList: ICenter[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getContactsData: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number, limitStart: number, limitEnd: number) => Promise<IDashContactsResponse>,
    getContactsDataExport: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number, limitStart: number, limitEnd: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    centerList: ICenterBase[]
    contactsData: IDashContacts[]
    includeNkr: boolean,
    includeDash: boolean,
    startDate: string,
    endDate: string,
    organType: number,
    includeNdd: boolean,
    includeDd: boolean,
    includeSv: boolean,
    includeFv: boolean,
    ruleOut: number,
    emrStatus: number,
    centerId: number,
    limitStart: number,
    limitEnd: number,
    recordCount: number
}

const getDateWeekAgo = () => {
    var oneWeekago = new Date();
    oneWeekago.setDate(oneWeekago.getDate() - 7)
    return oneWeekago.toISOString().split('T')[0];
}

const getTodaysDate = () => {
    var todays = new Date();
    return todays.toISOString().split('T')[0];
}

class Contacts extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerList: [],
        contactsData: [],
        includeNkr: true,
        includeDash: false,
        startDate: getDateWeekAgo(),
        endDate: getTodaysDate(),
        organType: 3,
        includeNdd: true,
        includeDd: true,
        includeSv: true,
        includeFv: true,
        ruleOut: 0,
        emrStatus: 0,
        centerId: 0,
        limitStart: 1,
        limitEnd: 2000,
        recordCount: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let newType = this.props.app.site.organType == OrganType.Kidney ? 3 : 2;
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI("organType=" + newType));
        let cookies = new Cookies();

        cookies.remove("dashview", { path: '/' });

        let organTypeFromCookie = cookies.get('organType');

        if (organTypeFromCookie == null) {
            const current = new Date();
            const nextYear = new Date();

            nextYear.setFullYear(current.getFullYear() + 1);

            cookies.set("organType", newType, { path: "/", expires: nextYear, domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });

            organTypeFromCookie = newType;
        } else {
            if (this.props.app.site.organType != OrganType.Kidney) {
                organTypeFromCookie = 2;
            }
        }

        let organTypeForPayload = organTypeFromCookie;

        if (parsed.organType != null) {
            organTypeForPayload = parsed.organType;
        }

        let { centerId: centerNum } = this.props;

        let payload: ContactsPayload = {
            includeDash: parsed.sites != null ? parsed.sites.indexOf('dash') >= 0 : false,
            includeNkr: parsed.sites != null ? parsed.sites.indexOf('nkr') >= 0 : true,
            startDate: parsed.startDate !== null && parsed.startDate !== undefined && parsed.endDate !== "" ? parsed.startDate : this.state.startDate,
            endDate: parsed.endDate !== null && parsed.endDate !== undefined && parsed.endDate !== "" ? parsed.endDate : this.state.endDate,
            organType: organTypeForPayload,
            includeNdd: parsed.includeNdd != null ? parseInt(parsed.includeNdd) >= 0 : true,
            includeDd: parsed.includeDd != null ? parseInt(parsed.includeDd) >= 0 : true,
            includeSv: parsed.includeSv != null ? parseInt(parsed.includeSv) >= 0 : true,
            includeFv: parsed.includeFv != null ? parseInt(parsed.includeFv) >= 0 : true,
            ruleOut: parsed.ruleOut != null ? parseInt(parsed.ruleOut) : 0,
            emrStatus: parsed.ruleOut != null ? parseInt(parsed.ruleOut) : 0,
            centerId: centerNum !== null || centerNum > 0 ? centerNum : 0,
            limitStart: 1,
            limitEnd: 2000,
        }

        let { includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd } = payload;

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            Promise.all([
                this.props.getBasicCenterList(),
                this.props.getContactsData(includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd)
            ])
                .then(([centerListResponse, contactsDataResponse]) => {
                    let { results: centerList } = centerListResponse.data;
                    let { reportResults } = contactsDataResponse.data.results;

                    let contactsData = [];
                    let recordCount = 0;

                    if (reportResults.list !== null && reportResults.list.length > 0) {
                        contactsData = reportResults.list;
                        recordCount = reportResults.listCount;
                    }

                    this.setState({
                        centerList,
                        centerId
                    }, () => {
                        this.setState({
                            contactsData,
                            recordCount,
                            includeNkr,
                            includeDash,
                            startDate,
                            endDate,
                            organType,
                            includeNdd,
                            includeDd,
                            includeSv,
                            includeFv,
                            ruleOut,
                            emrStatus,
                            centerId,
                            limitStart,
                            limitEnd
                        }, () => {
                            if (this.props.isAdmin == false) {
                                this.setConversionUrl();
                            }

                            this.props.hideLoading();
                        });
                    })

                }).catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    updateData = () => {
        let { includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd } = this.state;

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            this.props.getContactsData(includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd)
                .then(contactsDataResponse => {
                    let { reportResults } = contactsDataResponse.data.results;

                    let contactsData = [];
                    let recordCount = 0;

                    if (reportResults.list !== null && reportResults.list.length > 0) {
                        contactsData = reportResults.list;
                        recordCount = reportResults.listCount;
                    }

                    this.setState({
                        contactsData,
                        recordCount,
                        includeNkr,
                        includeDash,
                        startDate,
                        endDate,
                        organType,
                        includeNdd,
                        includeDd,
                        includeSv,
                        includeFv,
                        ruleOut,
                        emrStatus,
                        centerId,
                        limitStart,
                        limitEnd
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                })
                .catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    handleFilter = () => {
        let { includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd } = this.state;
        
        if (!includeNkr && !includeDash){
            includeNkr = true;
        }

        if (!includeNdd && !includeDd && !includeSv && !includeFv){
            includeNdd = true;
            includeDd = true;
            includeSv = true;
            includeFv = true;
        }

        this.setState({
            includeNkr,
            includeDash,
            startDate,
            endDate,
            organType,
            includeNdd,
            includeDd,
            includeSv,
            includeFv,
            ruleOut,
            emrStatus,
            centerId,
            limitStart,
            limitEnd
        }, () => {
            if (this.props.isAdmin == false) {
                this.setConversionUrl();
            }

            this.updateData();
        });
    }

    handleFilterChange = (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number) => {
        this.setState({
            includeNkr,
            includeDash,
            startDate,
            endDate,
            includeNdd,
            includeDd,
            includeSv,
            includeFv,
            ruleOut,
            emrStatus,
            centerId
        });
    }

    handleTurnPage = (limit: number) => {
        this.setState({
            limitStart: limit
        }, () => {
            this.handleFilter()
        });
    }

    handleExport = () => {
        let { includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd } = this.state;

        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getContactsDataExport(includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd)
                .then((response: any) => {
                    downloadFile(response.data, `Contacts.csv`, 'text/csv');
                    this.props.hideLoading();
                })
                .catch(() => {
                    alert("Error exporting the data")
                    this.props.hideLoading();
                });
        }).catch(() => {
            this.props.hideLoading();
        });;
    }

    handleOrganFilter = (organType: number) => {
        this.setState({
            organType
        }
            , () => {
                this.handleFilter()
            });
    }

    setConversionUrl = () => {
        let { includeNkr, includeDash, startDate, endDate, organType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, limitStart, limitEnd } = this.state;

        let paramList = [];

        if (includeNkr) {
            paramList.push(encodeURI('sites[]=nkr'))
        }

        if (includeDash) {
            paramList.push(encodeURI('sites[]=dash'))
        }

        if (startDate != '' && startDate != null && startDate != undefined) {
            paramList.push(encodeURI('startDate=' + startDate))
        }

        if (endDate != '' && endDate != null && endDate != undefined) {
            paramList.push(encodeURI('endDate=' + endDate))
        }

        if (organType != 0) {
            paramList.push(encodeURI('organType=' + organType))
        }

        if (includeNdd) {
            paramList.push(encodeURI('includeNdd=1'))
        }

        if (includeDd) {
            paramList.push(encodeURI('includeDd=1'))
        }

        if (includeSv) {
            paramList.push(encodeURI('includeSv=1'))
        }

        if (includeFv) {
            paramList.push(encodeURI('includeFv=1'))
        }

        if (includeNkr) {
            paramList.push(encodeURI('includeNkr=1'))
        }

        if (ruleOut != 0) {
            paramList.push(encodeURI('ruleOut=' + ruleOut));
        }

        if (emrStatus != 0) {
            paramList.push(encodeURI('emrStatus=' + emrStatus));
        }

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/contacts?' + params;

        window.history.pushState({}, '', newUrl);
    }

    getOrganTypeTitle = () => {
        if (this.state.organType == 1) {
            return 'Kidney Only';
        }

        if (this.state.organType == 2) {
            return 'Liver Only';
        }

        if (this.state.organType == 3) {
            return 'Liver & Kidney';
        }
    }

    render = () => {
        const organTypeTitle = this.getOrganTypeTitle();

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginBottom: 5 }}>
                        <Button style={{ marginRight: 30 }} onClick={this.handleExport}>Export CSV</Button>
                        <span>
                            <div>View:&nbsp;
                                <DropdownButton bsStyle='primary' disabled={this.props.app.site.organType == OrganType.Liver} pullRight title={organTypeTitle} id='organType'>
                                    <MenuItem onClick={() => this.handleOrganFilter(2)}>Liver Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(1)}>Kidney Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(3)}>Liver &amp; Kidney Candidates</MenuItem>
                                </DropdownButton>
                            </div>
                        </span>
                    </div>

                    <Filter
                        isAdmin={this.props.isAdmin}
                        includeNkr={this.state.includeNkr}
                        includeDash={this.state.includeDash}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        includeNdd={this.state.includeNdd}
                        includeDd={this.state.includeDd}
                        includeSv={this.state.includeSv}
                        includeFv={this.state.includeFv}
                        ruleOut={this.state.ruleOut}
                        emrStatus={this.state.emrStatus}
                        centerId={this.state.centerId}
                        centerList={this.state.centerList}
                        onFilterChange={this.handleFilterChange}
                        onFilter={this.handleFilter}
                    />

                    <NumbersToSelect
                        returnedRows={this.state.recordCount}
                        onTurnPage={this.handleTurnPage}
                    />

                    <Grid
                        centerId={this.state.centerId}
                        contactsData={this.state.contactsData}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        centerList: appState.centers.list,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getContactsData: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number, limitStart: number, limitEnd: number) => {
            return dispatch(ReportActionCreators.getContactsData(includeNkr, includeDash, startDate, endDate, donationType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd));
        },
        getContactsDataExport: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number, limitStart: number, limitEnd: number) => {
            return dispatch(ReportActionCreators.getContactsDataExport(includeNkr, includeDash, startDate, endDate, donationType, includeNdd, includeDd, includeSv, includeFv, ruleOut, emrStatus, centerId, limitStart, limitEnd));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Contacts);